module.exports = __webpack_public_path__ + "img/GS_Profile-Christelle Botha.413fd8c4.png";